// Resources
import { IStyles } from '../../../resource';

// Define Styles
const styles: IStyles = {
  dialog: (theme) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(30, 0),
    p: {
      xs: theme.spacing(42, 20, 20),
      sm: theme.spacing(42, 60, 24),
      md: theme.spacing(49, 80, 26),
      lg: theme.spacing(49, 115, 26),
    },
    position: 'relative',
    width: { xs: 'calc(100vw - 40px)', md: 'calc(100vw - 120px)', lg: 'calc(100vw - 426px)' },
    maxWidth: 1200,
  }),
  templateCard: (theme) => ({
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.spacing(20, 0),
    p: 0,
    backgroundColor: theme.palette.common.white,
    width: 300,
    flexShrink: 0,
    overflow: 'hidden',
  }),
  templateImage: (theme) => ({
    height: 400,
    width: '100%',
    borderRadius: `${theme.spacing(20, 0)} ${theme.spacing(20, 0)} 0 0`,
    overflow: 'hidden',
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      objectPosition: 'top',
    },
  }),
  configSection: (theme) => ({
    p: theme.spacing(24),
  }),
};

// Export styles
export default styles;
